import styled from 'styled-components';
import { Card as DefaultCard } from 'styles';

export const Card = styled(DefaultCard)`
  background-color: ${props => props.theme.colors.background[props.variant]};
  border: ${props => props.border};
`;
